import Icon from '../../fragments/icon/Icon';
import Snapshot from './Snapshot.jsx';
import Tickets from './Tickets.jsx';
import Cta from '../../fragments/cta/Cta';
import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';
import ComponentHeading from '../../fragments/heading/ComponentHeading';
import TimelinePanel from '../timeline/TimelinePanel';
import RichText from '../../fragments/rich-text/RichText';

export default function EventDetails({ block }) {
  if (!block) return null;
  // console.log("block", block);

  return (
    <ComponentWrapper block={block} className="EventDetails">
      {block.heading && (
        <div className="l-grid">
          <ComponentHeading heading={block.heading} cta={block.cta} />
        </div>
      )}
      <div className={'l-grid'}>
        <div className="l-grid__col l-grid__col--l-6-12">
          <RichText html={block.contentHtml} />
        </div>
        <div className="l-grid__col l-grid__col--l-5-12 l-grid__col--l-push-1-12">
          <div className="colorDynamicBg">
            <Snapshot
              date={block.date}
              time={block.time}
              location={block.location}
              mapUrl={block.mapUrl}
              duration={block.duration}
              cost={block.cost}
              accessibility={block.accessibility}
              parking={block.parking}
            />
          </div>
        </div>

        {block.items && (
          <div
            className={
              'EventDetails-items l-grid__col l-grid__col--l-5-12 l-grid__col--l-push-2-12'
            }
          >
            {block.items.map((item, index) => {
              return (
                <TimelinePanel
                  item={item}
                  blockId={block.blockId}
                  index={index}
                  key={index}
                />
              );
            })}
          </div>
        )}
      </div>
    </ComponentWrapper>
  );
}
